import ProductCheckProvider from './ProductCheckContext';
import ProductCheck from './ProductCheck';


let Index = () => {
    return (
        <ProductCheckProvider>
            <ProductCheck />
        </ProductCheckProvider>
    )
}

export default Index;